import { writable } from "svelte/store";

export interface PunchoutSession {
  hours_expiration: number;
  is_active_punchout: boolean;
  link: string;
  procurement_system_name: string;
}

const PunchoutSessionStore = writable<PunchoutSession>(null);

export default PunchoutSessionStore;
